module.exports = __webpack_public_path__ + "static/media/placeholder-img.015abc8e.jpg";